module.exports = __webpack_public_path__ + "img/13_mark_s.34f7567f.png";